/**
 * Oct 2026 — Unsaved Edit Guard. Ledgers register their dirty state here;
 * anything that would lose those edits (browser close/refresh, in-app link
 * navigation, Finance tab switches) asks first.
 */
const dirtySources = new Map();
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(hasUnsaved()));

export function setUnsaved(key, count) {
  if (count > 0) dirtySources.set(key, count);
  else dirtySources.delete(key);
  notify();
}

export function hasUnsaved() {
  return dirtySources.size > 0;
}

export function unsavedCount() {
  let n = 0;
  dirtySources.forEach((c) => { n += c; });
  return n;
}

export function subscribeUnsaved(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function confirmDiscardUnsaved() {
  if (!hasUnsaved()) return true;
  const n = unsavedCount();
  return window.confirm(`You have ${n} row${n === 1 ? "" : "s"} with unsaved changes. Leave anyway and lose them?`);
}

let installed = false;
// Installed once from App: beforeunload for close/refresh, plus a capturing
// click guard on internal links so sidebar/tab navigation can't silently
// throw edits away (react-router's <Link> never sees a cancelled click).
export function installUnsavedGuard() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("beforeunload", (e) => {
    if (!hasUnsaved()) return;
    e.preventDefault();
    e.returnValue = "";
  });
  document.addEventListener("click", (e) => {
    if (!hasUnsaved() || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest?.("a[href]");
    if (!a || a.target === "_blank" || a.hasAttribute("download")) return;
    const url = new URL(a.href, window.location.href);
    if (url.origin !== window.location.origin) return;
    if (url.pathname + url.search === window.location.pathname + window.location.search) return;
    if (!confirmDiscardUnsaved()) { e.preventDefault(); e.stopPropagation(); }
  }, true);
}
